<template>
  <div>
    <b-modal ref="ingredient-modal" id="ingredient-modal" title="New Ingredient" hide-footer>
      <new-ingredient-form @addIngredient="onAddIngredient" />
    </b-modal>

    <b-button v-b-modal.ingredient-modal>New Ingredient</b-button>

    <hr />
    <h6>Hydration</h6>
    <h4 class="my-2">{{ hydrationText }}</h4>

    <br />
    <IngredientGrid :ingredients="sortedIngredients" />
  </div>
</template>

<script>
import IngredientGrid from '@/components/IngredientGrid'
import NewIngredientForm from '@/components/NewIngredientForm'
import { mapActions, mapGetters } from 'vuex'
import { checkFlour } from '@/utils/helpers'

export default {
  page: {
    title: 'Bakulator Basic',
    meta: [{ name: 'description', content: 'The Bakulator Basic page.' }]
  },
  components: {
    IngredientGrid,
    NewIngredientForm
  },
  computed: {
    ...mapGetters(['sortedIngredients', 'waterWeight', 'totalHydration']),
    hydrationText() {
      if (this.sortedIngredients.length === 0) {
        return 'Add some ingredients to get started!'
      }
      if (this.totalHydration === 0) {
        return 'Your dough is feeling pretty thirsty...'
      }
      if (!isFinite(this.totalHydration)) {
        return 'You might wanna add some flour...'
      }
      return +this.totalHydration.toFixed(2) + '%'
    }
  },
  methods: {
    ...mapActions(['addIngredient', 'addMainIngredient']),
    onAddIngredient(newIngredient) {
      this.$refs['ingredient-modal'].hide()
      if (checkFlour(newIngredient.name)) {
        this.addMainIngredient(newIngredient)
      } else {
        this.addIngredient(newIngredient)
      }
    }
  },
  created() {
    this.$store.dispatch('getAllIngredients')
  }
}
</script>

<style lang="scss" scoped>
.slide-height-enter-active,
.slide-height-leave-active {
  transition: height 0.5s;
}
.btn {
  background-color: #0368a0;
  border-color: #01273c;
}
</style>
